import { render } from "./CategoriaView.vue?vue&type=template&id=4be27022&scoped=true"
import script from "./CategoriaView.vue?vue&type=script&lang=js"
export * from "./CategoriaView.vue?vue&type=script&lang=js"

import "./CategoriaView.vue?vue&type=style&index=0&id=4be27022&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be27022"]])

export default __exports__